import Layout from '../Layout'
import { formatCurrency } from '../../lib/format'

interface Account {
  id: number
  name: string
  slug: string
}

interface Stats {
  total_sales: number
  total_revenue: number
  today_sales: number
  today_revenue: number
  month_sales: number
  month_revenue: number
  top_products: Record<string, number>
}

interface Props {
  account: Account
  stats: Stats
  permissions?: {
    can_view_reports: boolean
  }
  show_costs?: boolean
}

export default function ReportsIndex({ account, stats, permissions, show_costs }: Props) {
  return (
    <Layout account={account} permissions={permissions}>
      <h1 className="text-2xl font-bold text-[#202020] mb-6">Reportes</h1>

      <div className="grid md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white p-6 rounded-lg shadow">
          <p className="text-sm text-gray-500 mb-1">Hoy</p>
          <p className="text-2xl font-bold text-[#202020]">{stats.today_sales} ventas</p>
          <p className="text-lg text-[#55ACEE]">{formatCurrency(Number(stats.today_revenue))}</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <p className="text-sm text-gray-500 mb-1">Este mes</p>
          <p className="text-2xl font-bold text-[#202020]">{stats.month_sales} ventas</p>
          <p className="text-lg text-[#55ACEE]">{formatCurrency(Number(stats.month_revenue))}</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <p className="text-sm text-gray-500 mb-1">Total histórico</p>
          <p className="text-2xl font-bold text-[#202020]">{stats.total_sales} ventas</p>
          <p className="text-lg text-[#55ACEE]">{formatCurrency(Number(stats.total_revenue))}</p>
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow">
        <h2 className="text-xl font-semibold text-[#202020] mb-4">Productos más vendidos</h2>
        {Object.keys(stats.top_products).length === 0 ? (
          <p className="text-gray-500">No hay datos de ventas aún.</p>
        ) : (
          <div className="space-y-3">
            {Object.entries(stats.top_products).map(([name, revenue], index) => (
              <div key={name} className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <span className="text-sm font-medium text-gray-500 w-6">{index + 1}.</span>
                  <span className="font-medium">{name}</span>
                </div>
                <span className="text-[#55ACEE] font-medium">{formatCurrency(Number(revenue))}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  )
}
